// extracted by mini-css-extract-plugin
module.exports = {"EnergyBackup-detail":"EnergyBackup_EnergyBackup-detail__aO61Z"};